import { FEATURE_FLAG_NAMES, isFeatureEnabled, } from '@thoughtspot/feature-service';
import { translate as t } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { Tab, TabHeaderHorizontalAlignment, TabTrayLayout, TabTraySize, } from '@thoughtspot/radiant-react/widgets/tab';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { Video, VideoSize } from '@thoughtspot/radiant-react/widgets/video';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { useBlinkContextForGlobalNav } from '../../contexts/global-nav-blink-context';
import styles from './learning.module.scss';
import VideosJson from './learning-module.json';
export var VideoType;
(function (VideoType) {
    VideoType["BASIC"] = "basic";
    VideoType["ADVANCED"] = "advanced";
})(VideoType || (VideoType = {}));
export const LearningModuleContainer = ({ showHeader = true, }) => {
    const { metricsService } = useBlinkContextForGlobalNav();
    const learningModuleVideos = isFeatureEnabled(FEATURE_FLAG_NAMES.LEARNING_MODULE_VIDEOS);
    const [currentTab, setCurrentTab] = useState(VideoType.BASIC);
    const videosList = learningModuleVideos && Object.keys(learningModuleVideos).length !== 0
        ? learningModuleVideos
        : VideosJson;
    const sampleVideo = {
        title: 'Failed to load Video',
        source: 'sample source',
    };
    const [heroVideo, setHeroVideo] = useState(videosList[currentTab][0] || sampleVideo);
    const [currentVideoUrl, setCurrentVideoUrl] = useState(videosList[currentTab][0]?.source || sampleVideo.source);
    const handleVideoTitleClick = (videoConfig, idx) => {
        setHeroVideo(videoConfig);
        setCurrentVideoUrl(videoConfig.source);
        metricsService.collectEvent(new UserAction(userActionTypeEnum.HOME_LEARNING_SELECT_VIDEO), {
            video_title: videoConfig.title,
            video_type: currentTab,
            position: idx + 1,
        });
    };
    const VideoCard = (videoConfig, index, list) => {
        return (React.createElement(Horizontal, { className: cx(styles.videoCard, {
                [styles.active]: videoConfig.source === currentVideoUrl,
            }), key: videoConfig.source, "data-testid": "video-item", onClick: () => handleVideoTitleClick(videoConfig, index), tabIndex: 0, role: "button", "aria-label": `Play video: ${videoConfig.title}` },
            React.createElement("img", { src: videoConfig.thumbnail, alt: videoConfig.title }),
            React.createElement("div", null,
                videoConfig.source === currentVideoUrl && (React.createElement(Typography, { variant: "footnote", className: styles.status, "data-testid": `videoCurrentlyWatching-${videoConfig.title}` }, t('homepage.learing.module.currentlywatching'))),
                index !== 0 &&
                    index !== list.length &&
                    list[index - 1].source === currentVideoUrl && (React.createElement(Typography, { variant: "footnote", className: styles.status }, t('NEXT'))),
                React.createElement(Typography, { variant: "content-label-subhead", className: styles.title, "data-testid": `videoItem-${videoConfig.title}`, noMargin: true }, videoConfig.title))));
    };
    const videoList = (list) => {
        return list.map((videoConfig, index) => {
            return VideoCard(videoConfig, index, list);
        });
    };
    const handleTabClick = (item) => {
        const videoSource = item === 'basic'
            ? videosList.basic[0]?.source
            : videosList.advanced[0]?.source;
        setCurrentVideoUrl(videoSource);
        metricsService.collectEvent(new UserAction(userActionTypeEnum.HOME_VIDEO_TOGGLE), {
            video_type: item,
        });
    };
    useEffect(() => {
        setHeroVideo(videosList[currentTab][0]);
    }, [currentTab]);
    return (React.createElement("div", { className: cx(styles.container, styles.containerV3), "data-testid": "learning-module-main-container" },
        showHeader && (React.createElement(Typography, { variant: "h2" }, t('homepage.learing.module.title'))),
        React.createElement("div", { className: styles.videosContainer },
            React.createElement("div", { className: cx(styles.heroVideoContainer, styles.visibleLoader), "data-testid": "video-container" },
                React.createElement(Video, { source: heroVideo?.source, title: heroVideo?.title, isAutoplay: false, size: VideoSize.auto, className: styles.heroVideo, hideControls: false })),
            React.createElement("div", { className: styles.videoListContainer, "data-testid": "video-list" },
                React.createElement(Tab, { layout: TabTrayLayout.Horizontal, size: TabTraySize.Small, selectedTabId: currentTab, headerAlignment: TabHeaderHorizontalAlignment.CENTER, className: styles.tabContainer },
                    React.createElement(Tab.Item, { id: VideoType.BASIC, name: t('homepage.learing.module.vidoe.basic'), onTabItemClick: () => {
                            handleTabClick('basic');
                            setCurrentTab(VideoType.BASIC);
                        }, "data-testid": "basic-tab" },
                        React.createElement("div", { className: styles.videoList }, videoList(videosList.basic))),
                    React.createElement(Tab.Item, { id: VideoType.ADVANCED, name: t('homepage.learing.module.vidoe.advanced'), onTabItemClick: () => {
                            handleTabClick('advanced');
                            setCurrentTab(VideoType.ADVANCED);
                        } },
                        React.createElement("div", { className: styles.videoList }, videoList(videosList.advanced))))))));
};
//# sourceMappingURL=learning-module.container.js.map